import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../api/api";
import { setCurrentPage } from "../../redux/moviesReducer";

function Pagination() {
  const { totalResults, search, filmOrSeries, currentPage } = useSelector((state) => state.movies);
  const dispatch = useDispatch();
  const arr = [];
  for(let i = 1; i <= (totalResults > 15 ? 15 : totalResults); i++) {
      arr.push(i)
  }


  return (
    <ul className="pagination center">
      {  arr.map(link=>{
          const curPageClass = currentPage == link ? "active waves-effect" : "waves-effect"
          return <li className={curPageClass} key={link}><a href="#" onClick={(e)=>{
            e.preventDefault()
            API.search(dispatch, search, filmOrSeries, link)
            dispatch(setCurrentPage(link))
          }}>{link}</a></li>
          })
      }  
    </ul>
  );
}

export default Pagination;
